import * as React from "react"

export interface ImageBlockProps {
  readonly imageUrl: string
  readonly imageAlt: string
}

export const ImageBlock: React.StatelessComponent<ImageBlockProps> = p => (
  <div className="image-block__wrapper">
    <div className="image-block__inner">
      <img src={p.imageUrl} alt={p.imageAlt} className="image-block__image" />
    </div>
  </div>
)
